import { render, staticRenderFns } from "./TradingView.vue?vue&type=template&id=f7caf01e&scoped=true"
import script from "./TradingView.vue?vue&type=script&lang=js"
export * from "./TradingView.vue?vue&type=script&lang=js"
import style0 from "./TradingView.vue?vue&type=style&index=0&id=f7caf01e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7caf01e",
  null
  
)

export default component.exports